module.exports = __webpack_public_path__ + "static/img/200299.11736a42.png";